import { useEffect, useState } from "react";
import { getCollectionRequest } from "services/apiRequests";
import { usePlatform } from "components/utils/PlatformContext";

interface MyKnowledgePointsProps {}

const MyKnowledgePoints: React.FC<MyKnowledgePointsProps> = ({}) => {
  // States defintion
  const [points, setPoints] = useState(0);
  const [showNumber, setShowNumber] = useState(false);

  // Get the platform context
  const { knowledgeWatermark, knowledgeBadge } = usePlatform();

  /**
   * Get the data every time it's rendered
   */
  useEffect(() => {
    getData();
  }, []);

  /**
   * Function used to request the knowledge points
   */
  const getData = async () => {
    // Get the knowledge points
    const response = await getCollectionRequest("/api/users/knowledge-points");

    // Check if the response is successful
    if (!response.successful) {
      return;
    }

    // Update the points state
    setPoints(response.content);
    setShowNumber(true);

    return response;
  };

  return (
    <div className="self-stretch h-[362px] min-h-[362px] bg-neutral-25 rounded-3xl flex-col justify-between items-start flex overflow-hidden relative">
      {knowledgeWatermark && (
        <img
          className="absolute w-auto h-full right-0 select-none"
          src={knowledgeWatermark}
          alt="My knowledge points watermark"
        />
      )}
      <div className="self-stretch py-5 px-4 justify-between items-start inline-flex select-none">
        {knowledgeBadge && (
          <img
            src={knowledgeBadge}
            className="w-fit h-fit max-w-[88px] max-h-[88px] relative"
            alt="My knowledge points badge"
          />
        )}
      </div>
      {showNumber && (
        <div className="self-stretch p-6 justify-between items-end inline-flex z-10">
          <div className="grow shrink basis-0 flex-col justify-start items-start gap-4 inline-flex">
            <div className="self-stretch relative">
              <div className="text-neutral-700 text-[33px] font-semibold font-sans leading-10 select-none">
                {points}
              </div>
            </div>
            <div className="self-stretch h-fit flex-col justify-start items-start gap-2 flex">
              <div className="self-stretch text-neutral-700 text-lg font-normal font-sans leading-snug select-none">
                My Knowledge Points*
              </div>
              <div className="h-fit text-neutral-500 text-xs font-sans leading-[14px] select-none">
                <span className="font-normal">You have earned </span>
                <span className="font-semibold">{points} </span>
                <span className="font-normal">knowledge points</span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MyKnowledgePoints;
